import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaEnvelope, FaEye, FaEyeSlash } from "react-icons/fa";
import API from "../Context/api";
import ErrorMessage from "../Helpers/ErrorMessage";

function Register() {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await API.post("/auth/register", {
        firstname,
        lastname,
        email,
        password,
      });

      setErrorMessage("");
      setFirstname("");
      setLastname("");
      setEmail("");
      setPassword("");

      navigate("/email-verification", { state: { email } });
    } catch (error) {
      setErrorMessage(
        error.response
          ? error.response.data.message
          : "Network error, please try again later"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full sm:max-w-sm md:max-w-md bg-white shadow-md rounded-lg p-6 sm:p-8">
        <h1 className="text-xl sm:text-2xl font-bold text-center mb-4 sm:mb-6">
          Sign Up
        </h1>

        <ErrorMessage message={errorMessage} />

        <form onSubmit={handleSignUp}>
          {/* Firstname Field */}
          <div className="relative mb-3 sm:mb-4">
            <label
              htmlFor="firstname"
              className="block text-sm sm:text-base font-medium text-gray-700 mb-1"
            >
              First Name
            </label>
            <div className="relative">
              <input
                type="text"
                id="firstname"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md pr-10 focus:ring-2 focus:ring-blue-500 focus:outline-none text-sm sm:text-base"
                placeholder="Enter your first name"
                required
              />
              <FaUser className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            </div>
          </div>

          {/* Lastname Field */}
          <div className="relative mb-3 sm:mb-4">
            <label
              htmlFor="lastname"
              className="block text-sm sm:text-base font-medium text-gray-700 mb-1"
            >
              Last Name
            </label>
            <div className="relative">
              <input
                type="text"
                id="lastname"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md pr-10 focus:ring-2 focus:ring-blue-500 focus:outline-none text-sm sm:text-base"
                placeholder="Enter your last name"
                required
              />
              <FaUser className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            </div>
          </div>

          {/* Email Field */}
          <div className="relative mb-3 sm:mb-4">
            <label
              htmlFor="email"
              className="block text-sm sm:text-base font-medium text-gray-700 mb-1"
            >
              Email
            </label>
            <div className="relative">
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md pr-10 focus:ring-2 focus:ring-blue-500 focus:outline-none text-sm sm:text-base"
                placeholder="Enter your email"
                required
              />
              <FaEnvelope className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            </div>
          </div>

          {/* Password Field */}
          <div className="relative mb-4 sm:mb-6">
            <label
              htmlFor="password"
              className="block text-sm sm:text-base font-medium text-gray-700 mb-1"
            >
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md pr-10 focus:ring-2 focus:ring-blue-500 focus:outline-none text-sm sm:text-base"
                placeholder="Enter your password"
                required
              />
              {showPassword ? (
                <FaEyeSlash
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer"
                  onClick={() => setShowPassword(false)}
                />
              ) : (
                <FaEye
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer"
                  onClick={() => setShowPassword(true)}
                />
              )}
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isLoading}
            className={`w-full bg-blue-500 text-white py-2 rounded-md transition duration-200 text-sm sm:text-base ${
              isLoading ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-600"
            }`}
          >
            {isLoading ? "Loading..." : "Sign Up"}
          </button>
        </form>

        <p className="text-center text-sm sm:text-base text-gray-600 mt-4">
          Already have an account?{" "}
          <a href="/login" className="text-blue-500 hover:underline">
            Sign In
          </a>
        </p>
      </div>
    </div>
  );
}

export default Register;
